<!-- Header: title left, current values centred, timestamp and refresh right -->
<div class="d-flex align-items-center">
    <p class="fw-semibold mb-1 avs-fuelcell-header-side">Systemzustand</p>
    <div class="d-flex justify-content-center flex-wrap" [class.avs-fuelcell-stale]="!isEditable">
        <span>{{ data?.systemState != null ? getFuelCellSystemStateString(data!.systemState!) : 'k.A.' }}</span>
        <span class="ms-3">Arbeitsmodus: {{ getOperatingModeString(data?.operatingMode) }}</span>
    </div>
    <div class="d-flex align-items-center justify-content-end avs-fuelcell-header-side">
        <span *ngIf="information" class="text-danger small me-2">{{ information }}</span>
        <span *ngIf="data?.time" class="text-secondary small">Stand {{ data?.time | date: 'dd.MM.yyyy H:mm' }}</span>
        <img class="avs-icon-edit ms-2" role="button" height="20" src="assets/icons/arrow-clockwise.svg"
            alt="Aktualisieren" title="Aktualisieren" (click)="load()">
    </div>
</div>

<p *ngIf="isBusy" class="text-secondary small mb-1">{{ busyMessage }}</p>

<!-- Inputs, collapsed -->
<div class="mt-2" [class.avs-fuelcell-stale]="!isEditable">
    <div class="d-flex align-items-center avs-fuelcell-collapse-toggle" role="button"
        [attr.aria-expanded]="isCommandExpanded" title="Systemzustand ändern ein- oder ausklappen" (click)="isCommandExpanded = !isCommandExpanded">
        <img height="12" alt="" [src]="isCommandExpanded ? 'assets/icons/caret-down.svg' : 'assets/icons/caret-right.svg'">
        <span class="ms-1">Systemzustand ändern</span>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-1" *ngIf="isCommandExpanded">
        <mat-form-field>
            <mat-label>Befehl</mat-label>
            <mat-select [(ngModel)]="selectedCommand" name="systemCommand" [disabled]="!isEditable">
                <mat-option *ngFor="let command of commands" [value]="command.value"
                    [disabled]="isCommandDisabled(command.value)">
                    {{ command.asText }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <button class="btn btn-outline-success rounded-0 ms-2" type="button"
            [disabled]="!isEditable || selectedCommand === undefined" (click)="onSendClicked()">Speichern</button>
    </div>
</div>
